/**
 * Table — примитивы таблицы (shadcn). Наш стиль: arrow-const + ref-проп.
 */

import type {HTMLAttributes, Ref, TdHTMLAttributes, ThHTMLAttributes} from 'react';

import {cn} from '@lib/utils';

type TableProps = HTMLAttributes<HTMLTableElement> & {ref?: Ref<HTMLTableElement>};
type SectionProps = HTMLAttributes<HTMLTableSectionElement> & {ref?: Ref<HTMLTableSectionElement>};
type RowProps = HTMLAttributes<HTMLTableRowElement> & {ref?: Ref<HTMLTableRowElement>};
type HeadProps = ThHTMLAttributes<HTMLTableCellElement> & {ref?: Ref<HTMLTableCellElement>};
type CellProps = TdHTMLAttributes<HTMLTableCellElement> & {ref?: Ref<HTMLTableCellElement>};

export const Table = ({className, ref, ...props}: TableProps) => (
  <div className="relative w-full overflow-auto">
    <table ref={ref} className={cn('w-full caption-bottom text-sm', className)} {...props} />
  </div>
);

export const TableHeader = ({className, ref, ...props}: SectionProps) => (
  <thead ref={ref} className={cn('[&_tr]:border-b', className)} {...props} />
);

export const TableBody = ({className, ref, ...props}: SectionProps) => (
  <tbody ref={ref} className={cn('[&_tr:last-child]:border-0', className)} {...props} />
);

export const TableRow = ({className, ref, ...props}: RowProps) => (
  <tr
    ref={ref}
    className={cn(
      'border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted',
      className,
    )}
    {...props}
  />
);

export const TableHead = ({className, ref, ...props}: HeadProps) => (
  <th
    ref={ref}
    className={cn(
      'h-10 px-3 text-left align-middle text-xs font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0',
      className,
    )}
    {...props}
  />
);

export const TableCell = ({className, ref, ...props}: CellProps) => (
  <td
    ref={ref}
    className={cn('p-3 align-middle [&:has([role=checkbox])]:pr-0', className)}
    {...props}
  />
);
